export default __webpack_public_path__ + "static/media/congrats.8a12540f.webp";